module.exports = __webpack_public_path__ + "static/media/kyle-gawley.a4b5b0e6.jpg";